import { httpsCallable } from 'firebase/functions'
import {
  KEEP_SHARE_LINK,
  SET_PREVIOUS_STATE,
  // SET_SHARE_CONFIG,
  UPDATE_CURRENT_CONFIG,
  // SET_FILE_SHARE_CONFIG,
  SET_INITIALIZED,
} from './constants'
// import {
//   asyncActionStart,
//   asyncActionFinish,
//   asyncActionError,
// } from '../async/actions'
import equal from 'fast-deep-equal'
import {
  setChoices as setChoicesMain,
  setMode as setModeMain,
  changeKeyText as changeKeyTextMain,
  setTitleObj as setTitleObjMain,
  setWeightOn as setWeightOnMain,
  setHeadlineOn as setHeadlineOnMain,
  setColorOn as setColorOnMain,
  updateMysterySettings as updateMysterySettingsMain,
  setChoiceHDImages as setChoiceHDImagesMain,
  // setTitleActive as setTitleActiveMain,
} from '../homepage/actions'
import {
  setChoices as setChoicesRIG,
  setMode as setModeRIG,
  changeKeyText as changeKeyTextRIG,
  setTitleObj as setTitleObjRIG,
  // setTitleActive as setTitleActiveRIG,
  updateMysterySettings as updateMysterySettingsRIG,
  setChoiceHDImages as setChoiceHDImagesRIG,
} from '../rig/actions'
import {
  setPeople as setPeopleRTG,
  changeKeyTextRTG,
  setTitleObj as setTitleObjRTG,
  setEvenSplit as setEvenSplitRTG,
  setNumGroups as setNumGroupsRTG,
  setGroupNames as setGroupNamesRTG,
  setShowIcon as setShowIconRTG,
  setPickQuantity as setPickQuantityRTG,
  setRepresentativeIndexes as setRepresentativeIndexesRTG,
  setPickRepresentative as setPickRepresentativeRTG,
  setPresetGroups as setPresetGroupsRTG,
  groupPlanning as groupPlanningRTG,
  setGroupMethod as setGroupMethodRTG,
  updateSelfJoinSettings as updateSelfJoinSettingsRTG,
  // setTitleActive as setTitleActiveRTG,
} from '../rtg/actions'
import {
  setTitleObj as setTitleObjYNW,
  setInputMode as setInputModeYNW,
  setNumInputSet as setNumInputSetYNW,
  // setTitleActive as setTitleActiveYNW,
  updateMysterySettings as updateMysterySettingsYNW,
} from '../ynw/actions'
import {
  setTitleObj as setTitleObjRNG,
  setTypeOption as setTypeOptionRNG,
  setAutoSpinMerge as setAutoSpinMergeRNG,
  setMinValueStore as setMinValueRNG,
  setMaxValueStore as setMaxValueRNG,
  setIntervalValueStore as setIntervalValueRNG,
  setExcludeFieldValue as setExcludeFieldValueRNG,
  setInputMethod as setInputMethodRNG,
  setFormulaFieldValue as setFormulaFieldValueRNG,
  setDigitRanges as setDigitRangesRNG,
  setDigitNumber as setDigitNumberRNG,
  setResultsArray as setResultsArrayRNG,
  // setTitleActive as setTitleActiveRNG,
  updateMysterySettings as updateMysterySettingsRNG,
} from '../rng/actions'
import {
  setTitleObj as setTitleObjRLG,
  setInputModeStore as setInputModeRLG,
  setStyleModeStore as setStyleModeRLG,
  setCustomInputStore as setCustomInputRLG,
  // setTitleActive as setTitleActiveRLG,
  updateMysterySettings as updateMysterySettingsRLG,
} from '../rlg/actions'
import { updateAllSettings } from '../toolSettings/actions'
import getFirebase from '../../utils/firebase/firebase'
import {
  refactorSoundSettings,
  refactorSpinBehavior,
  refactorBgColorSettings,
  refactorToolBackgroundSettings,
  refactorEvenSplitRTG,
  refactorTitle,
} from '../../utils'
import cloneDeep from 'lodash.clonedeep'
import { functions, auth } from '../../utils/firebase/firebase'
import { setWebsiteMode } from '../common/actions'
import { ContinentActiveList } from '../../component/ReactRCG/data'
import {
  setTitleObj as setTitleObjRCG,
  setContinentsActive as setContinentsActiveRCG,
  setShowMode as setShowModeRCG,
  setChoices as setChoicesRCG,
  updateMysterySettings as updateMysterySettingsRCG,
} from '../rcg/actions'
import {
  setTitleObj as setTitleObjCFQ,
  setContinentsActive as setContinentsActiveCFQ,
  setShowMode as setShowModeCFQ,
  setChoices as setChoicesCFQ,
  updateMysterySettings as updateMysterySettingsCFQ,
  setAnswerChoiceCount as setAnswerChoiceCountCFQ,
} from '../cfq/actions'
import { isImageData } from '../../utils/imageUtil'
import {
  setTitleObj as setTitleObjRDG,
  setInputModeStore as setInputModeRDG,
  setDaysModeStore as setDaysModeRDG,
  setInputsStore as setInputsRDG,
  updateMysterySettings as updateMysterySettingsRDG,
  setChoices as setChoicesRDG,
} from '../rdg/actions'
import {
  setChoices as setChoicesRCW,
  changeKeyText as changeKeyTextRCW,
  setTitleObj as setTitleObjRCW,
  setShowMode as setShowModeRCW,
  setInputMethod as setInputMethodRCW,
  setMode as setModeRCW,
  updateAllColorWheelStates as updateAllColorWheelStatesRCW,
  updateMysterySettings as updateMysterySettingsRCW,
} from '../rcw/actions'
import {
  setTitleObj as setTitleObjNFL,
  setConferenceActive as setConferenceActiveNFL,
  setShowMode as setShowModeNFL,
  setChoices as setChoicesNFL,
  setTeamsActive as setTeamsActiveNFL,
  updateMysterySettings as updateMysterySettingsNFL,
} from '../nfl/actions'
import {
  setTitleObj as setTitleObjNBA,
  setConferenceActive as setConferenceActiveNBA,
  setShowMode as setShowModeNBA,
  setChoices as setChoicesNBA,
  setTeamsActive as setTeamsActiveNBA,
  updateMysterySettings as updateMysterySettingsNBA,
} from '../nba/actions'
import {
  setTitleObj as setTitleObjRSG,
  setCountryActive as setCountryActiveRSG,
  setShowMode as setShowModeRSG,
  setChoices as setChoicesRSG,
  updateMysterySettings as updateMysterySettingsRSG,
} from '../rsg/actions'
import {
  setTitleObj as setTitleObjMLB,
  setConferenceActive as setConferenceActiveMLB,
  setShowMode as setShowModeMLB,
  setChoices as setChoicesMLB,
  setTeamsActive as setTeamsActiveMLB,
  updateMysterySettings as updateMysterySettingsMLB,
} from '../mlb/actions'
import {
  setTitleObj as setTitleObjTDQ,
  setTypeActive as setTypeActiveTDQ,
  setTypeCount as setTypeCountTDQ,
  setCategory as setCategoryTDQ,
  setLevel as setLevelTDQ,
  setChoices as setChoicesTDQ,
  updateMysterySettings as updateMysterySettingsTDQ,
} from '../tdq/actions'

import {
  turnOffPremiumSettings,
  instantInitSettings,
} from '../toolSettings/actions'

import { disableAndRemoveAds, setSharePremium } from '../auth/actions'
import {
  setLinkInfo,
  setNotAvailableIndex,
  setCollectModeActive,
  setCollectDataStep,
  setGroupOccupyStatus,
} from '../collectResult/actions'
import { refreshTurntable } from '../turntable/actions'
import { validateShareImageLimit } from '../../utils/validationUtil'

const choiceHDImagesAction = {
  main: (choiceHDImages, dispatch) =>
    dispatch(setChoiceHDImagesMain(choiceHDImages)),
  rig: (choiceHDImages, dispatch) =>
    dispatch(setChoiceHDImagesRIG(choiceHDImages)),
}

const choicesAction = {
  main: (choices, dispatch) => dispatch(setChoicesMain(choices)),
  rig: (choices, dispatch) => dispatch(setChoicesRIG(choices)),
  rcw: (choices, dispatch) => dispatch(setChoicesRCW(choices)),
  // rtg: (people, dispatch) => dispatch(setPeopleRTG(people)),
}

const modesAction = {
  main: (mode, dispatch) => dispatch(setModeMain(mode)),
  rig: (mode, dispatch) => dispatch(setModeRIG(mode)),
  rcw: (mode, dispatch) => dispatch(setModeRCW(mode)),
  // rtg: () => {},
}

const keyTextsAction = {
  main: dispatch => dispatch(changeKeyTextMain()),
  rig: dispatch => dispatch(changeKeyTextRIG()),
  rcw: dispatch => dispatch(changeKeyTextRCW()),
  // rtg: dispatch => dispatch(changeKeyTextRTG()),
}

const titleObjAction = {
  main: (obj, dispatch) => dispatch(setTitleObjMain(obj)),
  rig: (obj, dispatch) => dispatch(setTitleObjRIG(obj)),
  rtg: (obj, dispatch) => dispatch(setTitleObjRTG(obj)),
  ynw: (obj, dispatch) => dispatch(setTitleObjYNW(obj)),
  rng: (obj, dispatch) => dispatch(setTitleObjRNG(obj)),
  rlg: (obj, dispatch) => dispatch(setTitleObjRLG(obj)),
  rcg: (obj, dispatch) => dispatch(setTitleObjRCG(obj)),
  cfq: (obj, dispatch) => dispatch(setTitleObjCFQ(obj)),
  rdg: (obj, dispatch) => dispatch(setTitleObjRDG(obj)),
  rcw: (obj, dispatch) => dispatch(setTitleObjRCW(obj)),
  nfl: (obj, dispatch) => dispatch(setTitleObjNFL(obj)),
  nba: (obj, dispatch) => dispatch(setTitleObjNBA(obj)),
  rsg: (obj, dispatch) => dispatch(setTitleObjRSG(obj)),
  mlb: (obj, dispatch) => dispatch(setTitleObjMLB(obj)),
  tdq: (obj, dispatch) => dispatch(setTitleObjTDQ(obj)),
}

const mysteryObjAction = {
  main: (mysteryWheelOn, mysteryResultOn, dispatch) =>
    dispatch(updateMysterySettingsMain(mysteryWheelOn, mysteryResultOn)),
  ynw: (mysteryWheelOn, mysteryResultOn, dispatch) =>
    dispatch(updateMysterySettingsYNW(mysteryWheelOn, mysteryResultOn)),
  rng: (mysteryWheelOn, mysteryResultOn, dispatch) =>
    dispatch(updateMysterySettingsRNG(mysteryWheelOn, mysteryResultOn)),
  rlg: (mysteryWheelOn, mysteryResultOn, dispatch) =>
    dispatch(updateMysterySettingsRLG(mysteryWheelOn, mysteryResultOn)),
  rcg: (mysteryWheelOn, mysteryResultOn, dispatch) =>
    dispatch(updateMysterySettingsRCG(mysteryWheelOn, mysteryResultOn)),
  cfq: (mysteryWheelOn, mysteryResultOn, dispatch) =>
    dispatch(updateMysterySettingsCFQ(mysteryWheelOn, mysteryResultOn)),
  rsg: (mysteryWheelOn, mysteryResultOn, dispatch) =>
    dispatch(updateMysterySettingsRSG(mysteryWheelOn, mysteryResultOn)),
  rcw: (mysteryWheelOn, mysteryResultOn, dispatch) =>
    dispatch(updateMysterySettingsRCW(mysteryWheelOn, mysteryResultOn)),
  rig: (mysteryWheelOn, mysteryResultOn, dispatch) =>
    dispatch(updateMysterySettingsRIG(mysteryWheelOn, mysteryResultOn)),
  rdg: (mysteryWheelOn, mysteryResultOn, dispatch) =>
    dispatch(updateMysterySettingsRDG(mysteryWheelOn, mysteryResultOn)),
  mlb: (mysteryWheelOn, mysteryResultOn, dispatch) =>
    dispatch(updateMysterySettingsMLB(mysteryWheelOn, mysteryResultOn)),
  nba: (mysteryWheelOn, mysteryResultOn, dispatch) =>
    dispatch(updateMysterySettingsNBA(mysteryWheelOn, mysteryResultOn)),
  nfl: (mysteryWheelOn, mysteryResultOn, dispatch) =>
    dispatch(updateMysterySettingsNFL(mysteryWheelOn, mysteryResultOn)),
  tdq: (mysteryWheelOn, mysteryResultOn, dispatch) =>
    dispatch(updateMysterySettingsTDQ(mysteryWheelOn, mysteryResultOn)),
}

// const titleActiveAction = {
//   main: (status, dispatch) => dispatch(setTitleActiveMain(status)),
//   rig: (status, dispatch) => dispatch(setTitleActiveRIG(status)),
//   rtg: (status, dispatch) => dispatch(setTitleActiveRTG(status)),
//   ynw: (status, dispatch) => dispatch(setTitleActiveYNW(status)),
//   rng: (status, dispatch) => dispatch(setTitleActiveRNG(status)),
//   rlg: (status, dispatch) => dispatch(setTitleActiveRLG(status)),
// }

export const createShareLink =
  (inputs, userRole) => async (dispatch, getState) => {
    // dispatch(asyncActionStart('share'))
    // const { sharePage, inputChecked, resultChecked, settingsChecked } = inputs
    const {
      sharePage,
      titleChecked,
      settingsChecked,
      shareCanEdit,
      shareMethod,
      noAdsChecked,
      isPremium,
      collectDataSettings,
    } = inputs
    const state = getState()
    const pageSupportsStorage = sharePage === 'main' || sharePage === 'rig'
    if (pageSupportsStorage) {
      // Share file and collect results: still need check image limit because premium plan will change.
      const error = validateShareImageLimit(
        shareMethod,
        userRole,
        state[sharePage].choices,
        state[sharePage].choiceHDImages,
      )
      if (error) {
        throw { error }
      }
    }

    const { lastCreate, createdCount } = state.share
    const user = auth.currentUser
    const fSettings = state.settings
    const fileKey = state.common.currentFileKey
    const quizMode = inputs.quizMode === true ? true : false

    let toolData = null
    let settingsData = null
    switch (sharePage) {
      case 'main':
        {
          // if (resultChecked) {     // dont support result checked
          //   toolData = {
          //     choices: JSON.parse(JSON.stringify([...fChoices])),
          //     mode: fMode,
          //   }
          // } else {
          const fChoices = state.main.choices
          const weightOn = state.main.weightOn
          const headlineOn = state.main.headlineOn
          const colorOn = state.main.colorOn
          // const tempChoices = JSON.parse(JSON.stringify([...fChoices]))
          const tempChoices = cloneDeep(fChoices)
          tempChoices.forEach(choice => {
            // choice.count = 0
            choice.filtered = false
            if (!weightOn && choice.weight) {
              delete choice.weight
            }
            if (!headlineOn && choice.headline) {
              delete choice.headline
            }
            if (!colorOn && choice.color) {
              delete choice.color
            }
          })
          toolData = {
            choices: tempChoices,
            mode: 0,
          }
          if (weightOn) {
            toolData['weightOn'] = weightOn
          }
          if (headlineOn) {
            toolData['headlineOn'] = headlineOn
          }
          if (colorOn) {
            toolData['colorOn'] = colorOn
          }
          // }
        }
        break
      case 'rig':
        {
          // if (resultChecked) {     // dont support result checked
          //   toolData = {
          //     choices: JSON.parse(JSON.stringify([...fChoices])),
          //     mode: fMode,
          //   }
          // } else {
          const fChoices = state.rig.choices
          // const tempChoices = JSON.parse(JSON.stringify([...fChoices]))
          const tempChoices = cloneDeep(fChoices)
          tempChoices.forEach(choice => {
            // choice.count = 0
            choice.filtered = false
          })
          toolData = {
            choices: tempChoices,
            mode: 0,
          }
          // }
        }
        break
      case 'rtg':
        {
          const {
            people,
            numGroups,
            evenSplit,
            groupNames,
            showIcon,
            pickQuantity,
            pickRepresentative,
            groupMethod,
            selfJoinSettings,
            differentSplit,
            groupSizes,
          } = state.rtg
          toolData = {
            numGroups,
            evenSplit,
            groupNames,
            showIcon,
            pickQuantity,
            pickRepresentative,
            groupMethod,
            selfJoinSettings,
            differentSplit,
            groupSizes,
          }
          if (shareMethod === 'Guest') {
            toolData['people'] = groupMethod === 'host' ? people : []
          }
        }
        break
      case 'ynw':
        {
          const inputMode = state.ynw.inputMode
          const numInputSet = state.ynw.numInputSet
          toolData = {
            inputMode,
            numInputSet,
          }
        }
        break
      case 'rlg':
        {
          const { inputMode, styleMode, customInput } = state.rlg
          toolData = {
            inputMode,
            styleMode,
            customInput,
          }
        }
        break
      case 'rcg':
      case 'cfq':
        {
          const { choices, showMode, continentsActive } = state[sharePage]
          toolData = {
            choices,
            showMode,
            continentsActive,
          }
          if (sharePage === 'cfq') {
            toolData.answerChoiceCount = state[sharePage].answerChoiceCount
          }
        }
        break
      case 'rng':
        {
          const {
            typeOption,
            autoSpinMerge,
            minValue,
            maxValue,
            intervalValue,
            excludeFieldValue,
            formulaFieldValue,
            inputMethod,
            digitRanges,
            digitNumber,
            resultsArray,
          } = state.rng
          if (typeOption === 0) {
            if (inputMethod === 'By Range') {
              //By range method
              toolData = {
                typeOption,
                minValue,
                maxValue,
                intervalValue,
                excludeFieldValue,
                inputMethod,
              }
            } else {
              toolData = {
                typeOption,
                inputMethod,
                formulaFieldValue,
              }
            }
          } else {
            const arr = Array.from(Array(resultsArray.length), () => null)
            toolData = {
              typeOption,
              autoSpinMerge,
              digitRanges: JSON.stringify(digitRanges),
              digitNumber,
              resultsArray: arr,
            }
          }
        }
        break
      case 'rdg':
        {
          const { inputMode, daysMode, inputs } = state.rdg
          toolData = {
            inputMode,
            daysMode,
            inputs,
          }
        }
        break
      case 'rcw':
        {
          const inputMethod = state.rcw.inputMethod
          const fChoices = state.rcw.choices
          const tempChoices = cloneDeep(fChoices)
          tempChoices.forEach(choice => {
            choice.filtered = false
          })
          toolData = {
            choices: tempChoices,
            mode: 0,
            inputMethod,
            ...(inputMethod === 'ColorWheel'
              ? {
                  colorWheel: state.rcw.colorWheel,
                }
              : {
                  showMode: state.rcw.showMode,
                }),
          }
        }
        break
      case 'nfl':
      case 'nba':
      case 'mlb':
        {
          const { choices, showMode, conferenceActive, teamsActive } =
            state[sharePage]
          toolData = {
            choices,
            showMode,
            conferenceActive,
            teamsActive,
          }
        }
        break
      case 'rsg':
        {
          const { choices, showMode, countryActive } = state.rsg
          toolData = {
            choices,
            showMode,
            countryActive,
          }
        }
        break
      case 'tdq':
        {
          const { choices, typeActive, typeCount, category, level } = state.tdq
          toolData = {
            choices,
            typeActive,
            typeCount,
            category,
            level,
          }
        }
        break
    }

    if (titleChecked) {
      if (toolData === null) {
        // in case if the wheel have no inputs
        toolData = {}
      }
      toolData['title'] = { ...state[sharePage].title }
      if (quizMode) {
        // no Result Title for quiz mode
        toolData['title'].popup = ''
      }
    }
    if (settingsChecked) {
      if (isPremium && shareMethod === 'Guest') {
        settingsData = cloneDeep(fSettings)

        replaceCustomization(settingsData)
      } else {
        settingsData = { ...fSettings }
      }
      if (settingsData.hasOwnProperty('_persist')) {
        delete settingsData._persist
      }
    }
    if (sharePage !== 'rtg') {
      const mysteryWheelOn = state[sharePage].mysteryWheelOn
      const mysteryResultOn = state[sharePage].mysteryResultOn
      toolData['mysteryWheelOn'] = mysteryWheelOn
      toolData['mysteryResultOn'] = mysteryResultOn
    }

    let websiteDefaultMode = 'Share'
    if (shareMethod === 'Collect') {
      websiteDefaultMode = 'Collect'
    }

    const dataFunctions = {
      page: sharePage,
      tool: toolData,
      settings: settingsData,
      websiteMode: shareCanEdit
        ? `${websiteDefaultMode}CanEdit`
        : `${websiteDefaultMode}ViewOnly`,
      shareMethod,
      noAdsChecked,
      settingsChecked,
      ...(quizMode && {
        quizMode,
      }),
    }

    if (shareMethod === 'Collect') {
      if (sharePage !== 'rtg') {
        dataFunctions['collectDataSettings'] = collectDataSettings
      } else {
        if (state.rtg.groupMethod === 'selfJoin') {
          const {
            numGroups,
            groupNames,
            pickRepresentative,
            selfJoinSettings,
            evenSplit,
            differentSplit,
            groupSizes,
          } = state.rtg
          const wheelChoices = groupPlanningRTG(
            selfJoinSettings,
            evenSplit,
            +numGroups,
            groupNames,
            pickRepresentative,
            differentSplit,
            groupSizes,
          )
          dataFunctions['wheelChoices'] = wheelChoices
        }
      }
    }

    if (user) {
      dataFunctions['userId'] = user.uid
      dataFunctions['ownerRole'] = userRole // at least is signed up user meaning subscriber
    }

    if (fileKey) {
      dataFunctions['fileKey'] = fileKey
    }

    const { hasStorage = false } =
      state.common.tabsData[state.common.currentTabIndex]
    if (hasStorage) {
      dataFunctions['hasStorage'] = hasStorage
    }

    // if (shareCanEdit) {
    //   dataFunctions['websiteMode'] = 'ShareCanEdit'
    // }

    try {
      if (toolData === null && settingsData === null) {
        // dispatch(asyncActionFinish('share'))
        return {
          path: 'original',
        }
      } else {
        let sameData = shareMethod === 'Guest' ? true : false //guest type init true
        // if (toolData !== null) {
        // if (sharePage === 'main' || sharePage === 'rig' || sharePage === 'rtg') {
        if (equal(dataFunctions, state.share.dataFunctions) === false) {
          //compare same as previous created link
          sameData = false
        }
        // if (shareCanEdit !== state.share.shareCanEdit[sharePage]) {
        //   sameData = false
        // }
        // let resetAllPath = false
        // if (
        //   equal(settingsData, state.share.settings) === false &&
        //   sameData === true
        // ) {
        //   sameData = false
        //   resetAllPath = true // reset all paths as settings apply to all pages
        // }
        // if (state.share.lastSharePath === undefined) {
        //   sameData = false
        // }
        if (sameData) {
          // dispatch(asyncActionFinish('share'))
          return {
            path: state.share.lastSharePath,
          }
        } else {
          const dataLength = JSON.stringify({ ...dataFunctions }).length
          if (
            dataLength > 990000 &&
            (shareMethod === 'Guest' ||
              (shareMethod !== 'Guest' && !state.auth.currentUser?.isPremium))
          ) {
            //firestore can only store up to 1Mb/doc. check data length less than 1Mb
            // dispatch(asyncActionError('share'))
            throw {
              error: 'Too many images/inputs, reduce some and try again.',
            }
          }
          const timeNow = new Date().getTime() / 1000
          let newLastCreate = lastCreate
          let newCreatedCount = createdCount
          if (lastCreate + 3600 > timeNow) {
            //still within 1 hour
            if (createdCount >= 20) {
              //limit how many times/hour
              // dispatch(asyncActionError('share'))
              throw {
                error:
                  'Try again after an hour, you created more than 20 links/hour',
              }
            }
            newCreatedCount = createdCount + 1
          } else {
            newCreatedCount = 1
            newLastCreate = timeNow
          }
          const createShareWheel = httpsCallable(
            functions,
            'createShareWheelV2',
          )
          const result = await createShareWheel({
            ...dataFunctions,
            useNameListKeyAll: true,
          })
          const data = result.data
          if (data.error) {
            console.log(data.error)
            // dispatch(asyncActionError('share'))
            throw {
              error: 'Error when creating the link, please try again 1',
            }
          }
          if (shareMethod === 'Guest') {
            //for Share as Guest
            dispatch(
              keepShareLink(
                dataFunctions,
                newLastCreate,
                newCreatedCount,
                data.path,
              ),
            )
          } else {
            //for share from file
            dispatch(
              updateCurrentConfig({
                shareMethod,
                fileSharePath: data.path,
                isPrivate: false, // default is false
              }),
            )
          }

          // dispatch(asyncActionFinish('share'))
          return {
            path: data.path,
          }
        }
      }
    } catch (error) {
      console.log(error)
      // dispatch(asyncActionError('share'))
      throw {
        error: error.error || 'Error when creating the link, please try again.',
      }
    }
  }

export const getShareLink = inputs => async (dispatch, getState) => {
  // dispatch(asyncActionStart('getShare'))
  const { sharePage, sharePath, quizMode } = inputs
  const fSharePath = sharePath.replace(/\//g, '')
  try {
    getFirebase() //it may happen first when site load
    const getShareWheel = httpsCallable(functions, 'getShareWheelV2')

    const result = await getShareWheel({
      page: sharePage,
      path: fSharePath,
    })
    const snap = result.data
    if (snap.error) {
      console.log(snap.error)
      // dispatch(asyncActionError('getShare'))
      throw {
        error: snap.error,
      }
    }
    const data = snap.data

    const pageHasQuiz = sharePage === 'rcg' || quizMode
    if (pageHasQuiz) {
      const quizMode = inputs.quizMode === true ? true : false
      const dataQuizMode = data.quizMode === true ? true : false
      if (dataQuizMode !== quizMode) {
        throw {
          error: 'This share link does not exist.',
        }
      }
    }

    // if time is beyond this timestamp but have no websitemode written, make it shareviewonly (Aug 12 2022 version default shareviewonly, but default change to sharecanedit after one day), after 3 months can delete this condition

    if ((sharePath.length === 6 || sharePath.length === 8) && data.noAds) {
      dispatch(setSharePremium(true))
      disableAndRemoveAds()
    }
    const websiteMode = data.websiteMode
      ? data.websiteMode
      : data.createdDate._seconds > 1660291860 //equal to Friday, 12 August 2022 16:11:00 GMT+08:00
      ? 'ShareViewOnly'
      : 'ShareCanEdit'
    // const shareCanEdit = websiteMode === 'ShareCanEdit'
    let inputChecked = false
    let settingsChecked = false
    if (sharePage !== 'rtg') {
      // exclude rtg page set website mode
      dispatch(setWebsiteMode(websiteMode))
      const oriState = getState()
      dispatch(
        setPreviousState(sharePage, oriState[sharePage], oriState.settings),
      )
    }
    if (websiteMode === 'CollectViewOnly') {
      dispatch(setCollectModeActive(true))
      const collectDataSettings = data.tool.collectDataSettings
      if (
        !collectDataSettings.collectNameChecked &&
        !collectDataSettings.collectEmailChecked
      ) {
        dispatch(setCollectDataStep('Pending'))
      }
      dispatch(
        setLinkInfo(data.ownerInfo, sharePage, fSharePath, collectDataSettings),
      )
    }
    let mysterySpin = false
    if (data.settings) {
      settingsChecked = true
      const refactoredMusic = refactorSoundSettings(data.settings.music)
      const refactoredBgColor = refactorBgColorSettings(data.settings.bgColor)
      const refactoredBehavior = refactorSpinBehavior(
        data.settings.spinBehavior,
      )
      const refactoredToolBackground = refactorToolBackgroundSettings(
        data.settings.toolBgTransparency,
      )
      if (refactoredBehavior.mysterySpin !== undefined) {
        mysterySpin = refactoredBehavior.mysterySpin
        delete refactoredBehavior.mysterySpin
      }
      const updatedSettings = {
        ...data.settings,
        bgColor: refactoredBgColor,
        music: refactoredMusic,
        spinBehavior: refactoredBehavior,
        toolBgTransparency: refactoredToolBackground.toolBgTransparency,
      }

      if (!updatedSettings.rtgSpinBehavior) {
        //add new rtg behavior
        updatedSettings['rtgSpinBehavior'] = {
          groupingDuration: 5,
          representativeDuration: 3,
        }
      }

      if (data.needReplaceCustomization) {
        replaceCustomization(updatedSettings)
      }
      if (!data.noAds) {
        updatedSettings['banners'] = {
          on: false,
        }
      }
      dispatch(updateAllSettings(updatedSettings, sharePage))
    }

    if (data.tool) {
      inputChecked = true
      const {
        title,
        mysteryWheelOn = mysterySpin, // old version settings.spinBehavior.mysterySpin, changed to mysteryWheelOn in each tools
        mysteryResultOn = false,
      } = data.tool
      if (title) {
        //added 5/7/2021 for title

        titleObjAction[sharePage](refactorTitle(title), dispatch)
      } else {
        titleObjAction[sharePage](
          { active: false, text: '', description: '', popup: '' },
          dispatch,
        )
      }

      if (sharePage !== 'rtg') {
        mysteryObjAction[sharePage](mysteryWheelOn, mysteryResultOn, dispatch)
      }

      if (sharePage === 'main' || sharePage === 'rig') {
        //because only these 2 pages have inputs
        const {
          choices,
          mode,
          weightOn = false,
          headlineOn = false,
          colorOn = false,
          choiceHDImages = [],
        } = data.tool
        let inputs = choices
        // if (sharePage === 'rtg') {
        //   inputs = people
        // }
        if (sharePage === 'main') {
          for (let input of inputs) {
            //refactor input.name image to input.data
            if (isImageData(input.name)) {
              input['data'] = input.name
              input.name = ''
            }
            delete input.count
          }
          dispatch(setWeightOnMain(weightOn))
          dispatch(setHeadlineOnMain(headlineOn))
          dispatch(setColorOnMain(colorOn))
        } else {
          inputs = inputs.map(({ count, ...rest }) => rest)
        }
        choicesAction[sharePage](inputs, dispatch)
        modesAction[sharePage](mode, dispatch)
        keyTextsAction[sharePage](dispatch)
        choiceHDImagesAction[sharePage](choiceHDImages, dispatch)
      } else if (sharePage === 'rcw') {
        const { choices, mode, showMode, inputMethod, colorWheel } = data.tool
        let inputs = choices
        dispatch(setInputMethodRCW(inputMethod))
        choicesAction[sharePage](inputs, dispatch)
        modesAction[sharePage](mode, dispatch)
        keyTextsAction[sharePage](dispatch)
        if (inputMethod === 'ColorWheel') {
          dispatch(updateAllColorWheelStatesRCW(colorWheel))
        } else {
          dispatch(setShowModeRCW(showMode))
        }
      } else if (sharePage === 'rtg') {
        const {
          people,
          numGroups = 2,
          evenSplit = 'Default',
          groupNames = ['', ''],
          showIcon = true,
          pickQuantity = 0,
          pickRepresentative = false,
          groupMethod,
          selfJoinSettings,
        } = data.tool
        if (groupMethod === 'host') dispatch(setPeopleRTG(people))
        dispatch(setNumGroupsRTG(numGroups))
        dispatch(setEvenSplitRTG(refactorEvenSplitRTG(evenSplit)))
        dispatch(setGroupNamesRTG(groupNames))
        dispatch(setShowIconRTG(showIcon))
        dispatch(setPickQuantityRTG(pickQuantity))
        dispatch(changeKeyTextRTG(showIcon))
        dispatch(setRepresentativeIndexesRTG([]))
        dispatch(setPickRepresentativeRTG(pickRepresentative))
        dispatch(setPresetGroupsRTG([]))
        dispatch(setGroupMethodRTG(groupMethod))
        dispatch(updateSelfJoinSettingsRTG(selfJoinSettings))
      } else if (sharePage === 'ynw') {
        const { numInputSet = 4, inputMode = 0 } = data.tool
        dispatch(setNumInputSetYNW(numInputSet))
        dispatch(setInputModeYNW(inputMode))
      } else if (sharePage === 'rlg') {
        const {
          inputMode = 0,
          styleMode = 'UPPERCASE',
          customInput = '',
        } = data.tool
        dispatch(setInputModeRLG(inputMode))
        dispatch(setStyleModeRLG(styleMode))
        dispatch(setCustomInputRLG(customInput))
      } else if (sharePage === 'rcg' || sharePage === 'cfq') {
        const {
          continentsActive = ContinentActiveList,
          showMode = data.quizMode ? 'Flag' : 'Flag & Name',
          choices = [],
        } = data.tool
        if (data.quizMode) {
          dispatch(setContinentsActiveCFQ(continentsActive))
          dispatch(setShowModeCFQ(showMode))
          dispatch(setChoicesCFQ(choices))
          const { answerChoiceCount = null } = data.tool
          dispatch(setAnswerChoiceCountCFQ(answerChoiceCount))
        } else {
          dispatch(setContinentsActiveRCG(continentsActive))
          dispatch(setShowModeRCG(showMode))
          dispatch(setChoicesRCG(choices))
        }
      } else if (sharePage === 'rng') {
        const {
          typeOption = 0,
          autoSpinMerge = false,
          minValue = 1,
          maxValue = 10,
          intervalValue = 1,
          excludeFieldValue = '',
          formulaFieldValue = '',
          inputMethod = 'By Range',
          digitNumber,
          digitRanges,
          resultsArray = [null, null, null, null],
        } = data.tool
        const refactoredTypeOption = typeOption === 0 ? 0 : 1
        dispatch(setTypeOptionRNG(refactoredTypeOption))
        if (typeOption === 0) {
          dispatch(setInputMethodRNG(inputMethod))
          if (inputMethod === 'By Range') {
            dispatch(setMinValueRNG(minValue))
            dispatch(setMaxValueRNG(maxValue))
            dispatch(setIntervalValueRNG(intervalValue))
            dispatch(setExcludeFieldValueRNG(excludeFieldValue))
          } else {
            dispatch(
              setFormulaFieldValueRNG(
                formulaFieldValue,
                formulaFieldValue === '',
              ),
            ) // true will redraw the wheel based on formula
          }
        } else {
          dispatch(setAutoSpinMergeRNG(autoSpinMerge))
          dispatch(
            setDigitRangesRNG(
              JSON.parse(digitRanges) || [
                [0, 9],
                [0, 9],
                [0, 9],
                [0, 9],
                [0, 9],
                [0, 9],
              ],
            ),
          )
          dispatch(setDigitNumberRNG(digitNumber || typeOption + 1)) // default 4
          dispatch(setResultsArrayRNG(resultsArray))
        }
      } else if (sharePage === 'rdg') {
        const {
          choices,
          inputMode = 2,
          daysMode = [
            'Monday',
            'Tuesday',
            'Wednesday',
            'Thursday',
            'Friday',
            'Saturday',
            'Sunday',
          ],
          inputs = [],
        } = data.tool

        // dispatch(setChoicesRDG(['30-10-2022'])) // dummy date to prevent blankwheel for collect mode
        dispatch(setInputsRDG(inputs)) // have to call this first to prevent blankwheel for collect mode
        dispatch(setInputModeRDG(inputMode))
        dispatch(setDaysModeRDG(daysMode))
        dispatch(setChoicesRDG(choices))
      } else if (sharePage === 'nfl') {
        const { conferenceActive, showMode, choices, teamsActive } = data.tool
        dispatch(setConferenceActiveNFL(conferenceActive))
        dispatch(setShowModeNFL(showMode))
        dispatch(setChoicesNFL(choices))
        dispatch(setTeamsActiveNFL(teamsActive))
      } else if (sharePage === 'nba') {
        const { conferenceActive, showMode, choices, teamsActive } = data.tool
        dispatch(setConferenceActiveNBA(conferenceActive))
        dispatch(setShowModeNBA(showMode))
        dispatch(setChoicesNBA(choices))
        dispatch(setTeamsActiveNBA(teamsActive))
      } else if (sharePage === 'rsg') {
        const { countryActive, showMode, choices } = data.tool
        dispatch(setCountryActiveRSG(countryActive))
        dispatch(setShowModeRSG(showMode))
        dispatch(setChoicesRSG(choices))
      } else if (sharePage === 'mlb') {
        const { conferenceActive, showMode, choices, teamsActive } = data.tool
        dispatch(setConferenceActiveMLB(conferenceActive))
        dispatch(setShowModeMLB(showMode))
        dispatch(setChoicesMLB(choices))
        dispatch(setTeamsActiveMLB(teamsActive))
      } else if (sharePage === 'tdq') {
        const { typeActive, typeCount, category, level, choices } = data.tool
        dispatch(setTypeActiveTDQ(typeActive))
        dispatch(setTypeCountTDQ(typeCount))
        dispatch(setCategoryTDQ(category))
        dispatch(setLevelTDQ(level))
        dispatch(setChoicesTDQ(choices))
      }
    }
    //process lastly after choices have been inserted
    if (websiteMode === 'CollectViewOnly') {
      if (data.tool.collectDataSettings.collectActionMode !== 'Done') {
        dispatch(setNotAvailableIndex(data.tool.notAvailableIndex, sharePage))
        dispatch(refreshTurntable(sharePage))
      }
    }

    // dispatch(asyncActionFinish('getShare'))
    return {
      path: fSharePath,
      // shareConfig: {
      //   shareCanEdit,
      //   inputChecked,
      //   settingsChecked,
      // },
    }
  } catch (error) {
    console.log(error)
    // dispatch(asyncActionError('getShare'))
    throw {
      error: error.error || 'Error when loading the link, please try again.',
    }
  }
}

export const getShareLinkRTW = sharePath => async (dispatch, getState) => {
  try {
    const fSharePath = sharePath.replace(/\//g, '')
    let innerSharePath = ''
    if (sharePath.startsWith('w-')) {
      innerSharePath = sharePath.slice(2) // Result: "example"
    } else {
      throw {
        error: 'Invalid',
      }
    }
    getFirebase() //it may happen first when site load
    const getShareWheel = httpsCallable(functions, 'getShareWheelV2')

    const result = await getShareWheel({
      page: 'rtg', //write rtg for firestore
      path: fSharePath,
    })
    const snap = result.data
    if (snap.error) {
      console.log(snap.error)
      // dispatch(asyncActionError('getShare'))
      throw {
        error: snap.error,
      }
    }
    const data = snap.data

    if (
      (innerSharePath.length === 6 || innerSharePath.length === 8) &&
      data.noAds
    ) {
      dispatch(setSharePremium(true))
      disableAndRemoveAds()
    }
    dispatch(setWebsiteMode(data.websiteMode))
    if (data.websiteMode === 'CollectViewOnly') {
      dispatch(setCollectModeActive(true))
      dispatch(
        setLinkInfo(data.ownerInfo, 'rtg', fSharePath, {
          ...data.tool.selfJoinSettings,
          wheelChoices: data.tool.wheelChoices,
          evenSplit: data.tool.evenSplit,
        }),
      )
      //write rtg for firestore
    }
    if (data.settings) {
      const updatedSettings = {
        ...data.settings,
      }

      if (data.needReplaceCustomization) {
        replaceCustomization(updatedSettings)
      }
      if (!data.noAds) {
        updatedSettings['banners'] = {
          on: false,
        }
      }
      dispatch(updateAllSettings(updatedSettings, 'rtw')) //write rtw for local
    }
    // dispatch(setChoicesRTW(data.tool.wheelChoices))
    dispatch(setGroupOccupyStatus(data.tool.groupOccupyStatus))
    return {
      wheelChoices: data.tool.wheelChoices,
      groupOccupyStatus: data.tool.groupOccupyStatus,
      evenSplit: data.tool.evenSplit,
    }
  } catch (error) {}
}

const replaceCustomization = settingsData => {
  settingsData['banners'] = {
    on: false,
  }
  settingsData['bgImage'] = {
    on: false,
    src: null,
  }
  settingsData['spinButton'] = {
    colorOn: false,
    color: '#3D3D3D',
    imageOn: false,
    image: null,
  }
  settingsData['music'] = {
    ...settingsData['music'],
    customOn: false,
    starting: settingsData.music.starting,
    spinning: settingsData.music.spinning.includes('http')
      ? 'tick-sound'
      : settingsData.music.spinning,
    celebrating: settingsData.music.celebrating.includes('http')
      ? 'celebration-sound'
      : settingsData.music.celebrating,
  }
  settingsData['wheelColors'] = {
    colors:
      settingsData.wheelColors.arrayKey === 'Custom'
        ? ['#2B580C', '#F7B71D', '#AFA939', '#FDEF96']
        : settingsData.wheelColors.colors,
    arrayKey:
      settingsData.wheelColors.arrayKey === 'Custom'
        ? 'Default'
        : settingsData.wheelColors.arrayKey,
    index: settingsData.wheelColors.index,
  }
  settingsData['bgColor'] = {
    color:
      settingsData.bgColor.theme === 'Custom'
        ? '#B1BDA8'
        : settingsData.bgColor.color,
    theme:
      settingsData.bgColor.theme === 'Custom'
        ? 'Default'
        : settingsData.bgColor.theme,
  }
}

export const keepShareLink = (data, lastCreate, createdCount, path) => ({
  type: KEEP_SHARE_LINK,
  payload: {
    data,
    lastCreate,
    createdCount,
    path,
  },
})

// export const setShareConfig = shareConfig => ({
//   type: SET_SHARE_CONFIG,
//   payload: {
//     shareConfig,
//   },
// })

export const updateCurrentConfig = config => ({
  type: UPDATE_CURRENT_CONFIG,
  payload: {
    config,
  },
})

export const instantInit =
  (page, useShareState, isPremium = false) =>
  async (dispatch, getState) => {
    let previousPageState = null
    let previousSettings = null
    if (!useShareState) {
      const state = getState()
      previousPageState = state.share.previousState[page]
      previousSettings = state.share.previousState.settings
    }

    dispatch({
      type: `INSTANT_INIT_${page.toUpperCase()}`,
      payload: {
        previousState: previousPageState,
      },
    })
    if (useShareState && !isPremium) {
      dispatch(turnOffPremiumSettings())
    } else {
      dispatch(instantInitSettings(previousSettings))
    }
    if (!useShareState) {
      dispatch({
        type: `SHOW_TURNTABLE_${page.toUpperCase()}`, //to change wheel colors
        payload: {
          turntable: null,
        },
      })
    }

    // const currentWheelColorsKey = state.settings.wheelColors.arrayKey
    // if (!useShareState || currentWheelColorsKey === 'Custom') {
    //   // redraw to default colors if it is shareViewOnly or is Custom
    //   dispatch({
    //     type: `SHOW_TURNTABLE_${page.toUpperCase()}`, //to change wheel colors
    //     payload: {
    //       turntable: null,
    //     },
    //   })
    // }
  }

const setPreviousState = (page, previousState, settings) => ({
  type: SET_PREVIOUS_STATE,
  payload: {
    previousState: {
      [page]: previousState,
      settings,
    },
  },
})

// export const setFileShareConfig = fileShareConfig => ({
//   type: SET_FILE_SHARE_CONFIG,
//   payload: {
//     fileShareConfig,
//   },
// })

export const setInitialized = status => ({
  type: SET_INITIALIZED,
  payload: {
    status,
  },
})

export const changePrivacy = async data => {
  try {
    const changePrivacy = httpsCallable(functions, 'changePrivacy')
    return await changePrivacy(data)
  } catch (error) {
    throw {
      error: error.error,
    }
  }
}

export const changeShareCanEdit = async data => {
  try {
    const changeShareCanEdit = httpsCallable(functions, 'changeShareCanEdit')
    return await changeShareCanEdit(data)
  } catch (error) {
    throw {
      error: error.error,
    }
  }
}
